import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Tragik,
  voices: {
    main: {
      description:
        "theatrical sorceress alto, dramatic Eastern European-flavored vowels, wounded grandeur, smoky stage projection, shimmering occult room tone",
      seed: 10505,
      guidance: 0.76,
      loudness: 0.78,
      fx: { reverb: 0.18, eq: "dark" },
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "I have mutant powers, and a little demonic magic too.",
      },
      { id: "select_2", text: "Doesn't your team need a bit of Tragik?" },
      {
        id: "select_3",
        text: "Tragik's here, and I brought a little Limbo with me.",
      },
      { id: "select_4", text: "I'm Tragik, and this is my Soulsword." },
    ],
    spawn: [
      { id: "spawn_1", text: "This ends with our foes in chains!" },
      {
        id: "spawn_2",
        text: "Shall we show them what we have up our sleeves, Stephen?",
      },
      { id: "spawn_3", text: "Limbo's demons will deliver oblivion." },
      {
        id: "spawn_4",
        text: "Let's give them a taste of the Outervoids, Robbins.",
      },
      {
        id: "spawn_5",
        text: "I was an ordinary mutant girl until my soul got put through a demonic blender.",
      },
      {
        id: "spawn_6",
        text: "My brother and I are about as different as we could be.",
      },
      { id: "spawn_7", text: "You don't know me? A shame… but you will." },
      {
        id: "spawn_8",
        text: "I forged my sword with my very soul, there's no spell it cannot cut through.",
      },
      {
        id: "spawn_9",
        text: "I try to embrace what I've experienced. My strife has given me strength.",
      },
      {
        id: "spawn_10",
        text: "When things get…tense, the Darkchild tends to come out.",
      },
      {
        id: "spawn_11",
        text: "My soul remains noble, as my sword stays bright.",
      },
      {
        id: "spawn_12",
        text: "The Soulsword can destroy just about anything.",
      },
      {
        id: "spawn_13",
        text: "Me? Just a demon-haunted mutant girl out to save the universe.",
      },
      { id: "spawn_14", text: "If you see my brother…tell him I miss him." },
      {
        id: "spawn_15",
        text: "I'm a little cynical. Probably the Russian in me.",
      },
      { id: "spawn_16", text: "You know, I grew up in a demonic dimension~" },
    ],
    respawn: [
      { id: "respawn_1", text: "My soul is stubborn." },
      { id: "respawn_2", text: "Limbo doesn't let go that easy." },
      { id: "respawn_3", text: "I climbed out of Limbo, THIS is nothing." },
      { id: "respawn_4", text: "Haha! Back from Limbo!" },
      { id: "respawn_5", text: "Have Soulsword, will travel." },
      { id: "respawn_6", text: "Tragik is back!" },
      { id: "respawn_7", text: "You're not rid of me yet." },
    ],
    ult_ally: [{ id: "ult_ally", text: "Limbo stands with you!" }],
    ult_enemy: [{ id: "ult_enemy", text: "Behold: Darkchild!" }],
    secondary: [
      { id: "secondary_1", text: "Come, my minion." },
      { id: "secondary_2", text: "Go have fun!" },
      { id: "secondary_3", text: "From Limbo…" },
    ],
    ability2: [
      { id: "ability2_1", text: "Charge!" },
      { id: "ability2_2", text: "I got you!" },
      { id: "ability2_3", text: "Survive THIS!" },
      { id: "ability2_4", text: "Look at you fly!" },
      { id: "ability2_5", text: "Upsy daisy!" },
      { id: "ability2_6", text: "The Limbo Liftoff!" },
    ],
    kill: [
      { id: "kill_1", text: "Straight to your soul!" },
      { id: "kill_2", text: "Did I break your spirit?" },
      { id: "kill_3", text: "Just another soul." },
      { id: "kill_4", text: "This war is bigger than one life." },
      { id: "kill_5", text: "That's why they call me Tragik." },
      { id: "kill_6", text: "One more for the Soulsword!" },
      { id: "kill_7", text: "The Soulsword feeds…" },
      { id: "kill_8", text: "Too easy." },
      { id: "kill_9", text: "Just a little love tap." },
    ],
    multikill: [
      { id: "multikill_1", text: "On a little hot streak." },
      { id: "multikill_2", text: "Three? Soulsword's still hungry." },
      { id: "multikill_3", text: "I'll take three…until four comes along." },
      { id: "multikill_4", text: "Five for the Darkchild." },
      { id: "multikill_5", text: "The Soulsword wants six!" },
      { id: "multikill_6", text: "Five gone to Limbo!" },
      { id: "multikill_7", text: "None left for you guys, sorry!" },
      {
        id: "multikill_8",
        text: "Darkchild gets greedy sometimes, doesn't she?",
      },
      { id: "multikill_9", text: "Try a little harder to keep up, okay?" },
    ],
    low_hp: [
      { id: "low_hp_1", text: "I was fine!" },
      { id: "low_hp_2", text: "Nice little pick-me-up." },
    ],
    healed: [
      { id: "healed_1", text: "Just in time, thanks." },
      { id: "healed_2", text: "Whew, I was in trouble." },
      { id: "healed_3", text: "My strength is back." },
      { id: "healed_4", text: "Okay. This feels good." },
    ],
  },
} satisfies VoiceScript;

export default script;
